export default __webpack_public_path__ + "f8e18f0419057d0e38b48cca7c9e1097.png";